import uiActions from './ui/actions';
import globalActions from './global/actions';
import cartActions from './cart/actions';
import wishlistActions from './wishlist/actions';
import { store } from './store';

const ENTER_KEY = 13;

const dispatch = action => store() && store().dispatch(action);

const resize = evt =>
    dispatch(uiActions.windowResize(evt.target.innerWidth, evt.target.innerHeight));
const handleEnter = e => e.which === ENTER_KEY && dispatch(globalActions.enterClicked());

window.addEventListener('resize', resize);
document.addEventListener('keyup', handleEnter);

// Public events/actions
const addToCart = payload => dispatch(cartActions.addToCart(payload));
const bulkAddToCart = (orderEntries, redirectToCart, strictStockCheck, additionalInfo) =>
    dispatch(
        cartActions.bulkAddToCart({
            orderEntries,
            redirectToCart,
            strictStockCheck,
            additionalInfo,
        }),
    );
// const updateCart = payload => dispatch(cartActions.updateCart(payload));
const updateCart = payload => dispatch(cartActions.addOrUpdateCart(payload));

const removeFromCart = payload => dispatch(cartActions.removeFromCart(payload));
const addToWishlist = payload => dispatch(wishlistActions.addToWishlist(payload));
const removeFromWishlist = payload => dispatch(wishlistActions.removeFromWishlist(payload));

// window.__ecore2.store.dispatch({type: "CART.ADD_TO_CART", payload: { ... }) => window.dispatchEvent(new CustomEvent('add-to-cart', { detail: { ... } }))
window.addEventListener('add-to-cart', ({ detail }) => addToCart(detail));

// window.__ecore2.store.dispatch({type: "CART.UPDATE_CART", payload: { ... }) => window.dispatchEvent(new CustomEvent('update-cart', { detail: { ... } }))
window.addEventListener('update-cart', ({ detail }) => updateCart(detail));

// window.__ecore2.store.dispatch({type: "CART.REMOVE_FROM_CART", payload: { ... }) => window.dispatchEvent(new CustomEvent('remove-from-cart', { detail: { ... } }))
window.addEventListener('remove-from-cart', ({ detail }) => removeFromCart(detail));

window.addEventListener('add-to-wishlist', ({ detail }) => addToWishlist(detail));
window.addEventListener('remove-from-wishlist', ({ detail }) => removeFromWishlist(detail));
window.addEventListener('bulk-add-to-cart', ({ detail }) => bulkAddToCart(detail));
window.bulkAddToCart = bulkAddToCart;
